import React from 'react';
import type { AppType } from '../../../../common/constants';
import type { CommunicationWorkspaceConnection } from '../../../../services/types';
import { Workspace } from './workspace';

type Props = {
	workspaceConnections?: CommunicationWorkspaceConnection[];
	appType: AppType;
};

export const WorkspacesList = ({ workspaceConnections, appType }: Props) => (
	<>
		{workspaceConnections?.map((connection) => (
			<Workspace
				appType={appType}
				key={connection.connectionId || connection.id || ''}
				id={connection.connectionId || connection.id || ''}
				connection={connection}
			/>
		))}
	</>
);
